function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 8,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m0 59.82677l27.527777 -8.654488l-19.512508 -21.258898l28.167 6.268881l-6.268881 -28.167l21.258898 19.512508l8.654488 -27.527777l8.654491 27.527777l21.258896 -19.512508l-6.2688828 28.167l28.167 -6.268881l-19.512512 21.258898l27.527779 8.654488l-27.527779 8.654491l19.512512 21.258896l-28.167 -6.2688828l6.2688828 28.167l-21.258896 -19.512512l-8.654491 27.527779l-8.654488 -27.527779l-21.258898 19.512512l6.268881 -28.167l-28.167 6.2688828l19.512508 -21.258896z",
  fillRule: "evenodd"
});

var Svg23Star12 = function Svg23Star12(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 150 150",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg23Star12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/23-star-12.5d63be78.svg";
export { ForwardRef as ReactComponent };